import type { SearchApplicationsQuery } from './types';

export const isUnsatisfiableQuery = (query: SearchApplicationsQuery): boolean =>
  query.tab === 'unread_tasks' && Boolean(query.filters.tasks?.includes('all_clear'));
